import React, { useMemo } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getHamsKey } from '../../../services/product-to-hams-key';
import { PopupEntryPoint } from '../shared/popup-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint, type EntryPointParams } from './entrypoint';

export const CollectionChangePlanPopup = (): React.JSX.Element => {
	const { cloudId, collectionEntitlementId, product } = useEditionAwareness();

	const entryPointParams: EntryPointParams = useMemo(
		() => ({
			cloudId,
			collectionEntitlementId: `ari:cloud:commerce::entitlement/${collectionEntitlementId}`,
			hamsProductKey: getHamsKey(product),
			shouldShowPspLink: fg('twc_ea_pde_trial_psp_link'),
		}),
		[cloudId, collectionEntitlementId, product],
	);

	return (
		<PopupEntryPoint
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			placement={'bottom-end'}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
};
